export default class Area {
  constructor (data) {
    this.id = data.id
    this.nameFr = data.nameFr
  }
}
